import { RadioChangeEvent } from "antd";
import { JobApplication } from "../../../Entities/job-application.entity";
import { InterviewSession } from "../../../Interface/Index";
import useInterviewStartFlow from "./useInterviewStartFlow";
import useInterviewEvaluationFlow from "./useInterviewEvaluationFlow";
import useInterviewCommonHandlers from "./useInterviewCommonHandlers";


interface InterviewRoundsHandlersReturnType {
  // Common handlers
  handleSubmitStep: () => void;
  toggleToFullscreenMode: () => void;
  toggleToNormalScreenMode: () => void;
  handleCancelExit: () => void;
  handleConfirmExit: () => void;
  handleAnswerSingleQuestion: (index: number) => Promise<void>;
  handleBack: () => void;
  handleNext: () => Promise<void>;
  handleQuestionAnswerChange: (
    e: React.ChangeEvent<HTMLTextAreaElement> | RadioChangeEvent,
    value?: string | null
  ) => void;
  onNavigateToQuestions: () => void;

  // Start flow handlers
  handleStartInterview: () => void;
  handleCameraAccessConfirmation: () => Promise<void>;
  handleCancelCameraAccessConfirmation: () => void;
  handleCameraAccessdenied: () => void;
  getBrowserFingerPrint: () => Promise<string>;
  handleStartInterviewConfirmation: () => void;
  handleCancelStartInterview: () => void;

  // Evaluation flow handlers
  handleEvaluation: () => Promise<void>;
  handleRetryEvaluation: () => Promise<void>;
  handleUnqualifiedRound: (
    appliedJob: JobApplication,
    session: InterviewSession
  ) => Promise<void>;
}

const useInterviewRoundsHandlers = (): InterviewRoundsHandlersReturnType => {
  // Use the specialized hooks
  const startFlowHandlers = useInterviewStartFlow();
  const evaluationFlowHandlers = useInterviewEvaluationFlow();
  const commonHandlers = useInterviewCommonHandlers();

  return {
    // Common handlers
    ...commonHandlers,
    
    // Start flow handlers
    ...startFlowHandlers,
    
    // Evaluation flow handlers
    ...evaluationFlowHandlers,
  };
};

export default useInterviewRoundsHandlers;